'use client';

import CarouselComponent from '@ui/Carousel';
import type { BlogDocument } from '@util/types/firestore/blog';
import { useRef } from 'react';
import PaddockPostCard from './components/PaddockPost';

export default function ThePaddock({ posts }: { posts: BlogDocument[] }) {
  const carouselfRef = useRef<any>(null);

  return (
    <div className="mt-8 flex sm:overflow-y-hidden">
      <div className="relative w-full">
        <div
          className="no-scrollbar flex w-screen gap-x-4 overflow-x-scroll scroll-smooth pb-[1rem] sm:hidden sm:overflow-hidden sm:px-0"
          ref={carouselfRef}
        >
          {posts.map((post) => (
            <div className="flex-shrink-0" key={post.id}>
              <PaddockPostCard post={post} />
            </div>
          ))}
        </div>

        <CarouselComponent
          className="hidden sm:block"
          items={posts.map((post) => (
            <PaddockPostCard key={post.id} post={post} />
          ))}
          incrementBy={1}
          basis="basis-1/3.5"
        />
      </div>
    </div>
  );
}
